import './blanks-wholesale-levels.js?v=levels-20260921-12';
class BlanksCartShell extends HTMLElement {
  connectedCallback(){
    this.resize=new ResizeObserver(this.measure);
    this.changes=new MutationObserver(this.observeParts);
    this.changes.observe(this,{childList:true,subtree:true});this.observeParts();
    this.drawer=this.closest('theme-drawer');this.drawer?.addEventListener('theme-drawer:open',this.measure);
  }
  disconnectedCallback(){this.resize?.disconnect();this.changes?.disconnect();this.drawer?.removeEventListener('theme-drawer:open',this.measure);cancelAnimationFrame(this.frame);}
  observeParts=()=>{
    const header=this.querySelector('.boc-header'),footer=this.querySelector('.cart-drawer__summary');
    if(header!==this.header){if(this.header)this.resize.unobserve(this.header);this.header=header;if(header)this.resize.observe(header);}
    if(footer!==this.footer){if(this.footer)this.resize.unobserve(this.footer);this.footer=footer;if(footer)this.resize.observe(footer);}
    this.measure();
  };
  measure=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{
    const h=this.header?.getBoundingClientRect().height||64,f=this.footer?.getBoundingClientRect().height||0;
    this.style.setProperty('--boc-header-height',`${h}px`);this.style.setProperty('--boc-footer-height',`${f}px`);
  });};
}
if(!customElements.get('blanks-cart-shell'))customElements.define('blanks-cart-shell',BlanksCartShell);
